import { reportActionTypes } from '@/pages/report/Constants';

import type { PlaylistSection } from '@/pages/report/types';

export function getPlaylistSectionReportRequest(id: string) {
	return {
		type: reportActionTypes.GET_PLAYLIST_SECTION_REPORT_REQUEST,
		payload: {
			id,
		},
	};
}

export function getPlaylistSectionReportSuccess(data: PlaylistSection) {
	return {
		type: reportActionTypes.GET_PLAYLIST_SECTION_REPORT_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getPlaylistSectionReportError(error: unknown) {
	return {
		type: reportActionTypes.GET_PLAYLIST_SECTION_REPORT_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function clearState() {
	return {
		type: reportActionTypes.CLEAR_STATE,
	};
}
